import React from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import PeopleIcon from '@mui/icons-material/People';
import NotificationsIcon from '@mui/icons-material/Notifications';
import DnsIcon from '@mui/icons-material/Dns';
import StorageIcon from '@mui/icons-material/Storage';

const adminPages = [
  {
    title: 'Users Management',
    description: 'View and manage all platform users, trial extensions, and free minutes',
    icon: <PeopleIcon sx={{ fontSize: 48 }} />,
    path: '/admin/users',
  },
  {
    title: 'Notifications',
    description: 'Send and manage platform notifications for users',
    icon: <NotificationsIcon sx={{ fontSize: 48 }} />,
    path: '/admin/notifications',
  },
  {
    title: 'Infrastructure',
    description: 'Monitor EC2 instances and AWS costs',
    icon: <DnsIcon sx={{ fontSize: 48 }} />,
    path: '/admin/infrastructure',
  },
  {
    title: 'Server Status',
    description: 'Monitor media servers and signaling servers',
    icon: <StorageIcon sx={{ fontSize: 48 }} />,
    path: '/admin/server-status',
  },
];

function AdminDashboard() {
  const navigate = useNavigate();

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Admin Console
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: "text.secondary",
          mb: 3
        }}>
        Platform administration tools
      </Typography>
      <Grid container spacing={3}>
        {adminPages.map((page) => (
          <Grid
            key={page.path}
            size={{
              xs: 12,
              sm: 6,
              md: 4
            }}>
            <Paper
              sx={{
                p: 3,
                cursor: 'pointer',
                transition: 'all 0.2s',
                '&:hover': {
                  bgcolor: 'action.hover',
                  transform: 'translateY(-2px)',
                },
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                minHeight: 180,
                justifyContent: 'center',
              }}
              onClick={() => navigate(page.path)}
            >
              <Box sx={{ color: 'primary.main', mb: 2 }}>
                {page.icon}
              </Box>
              <Typography variant="h6" gutterBottom>
                {page.title}
              </Typography>
              <Typography variant="body2" sx={{
                color: "text.secondary"
              }}>
                {page.description}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default AdminDashboard;
